import { render } from "./ProfileViewComponent.vue?vue&type=template&id=6d702f6a"
import script from "./ProfileViewComponent.vue?vue&type=script&lang=js"
export * from "./ProfileViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__